module.exports = __webpack_public_path__ + "src/components/WhyHost/OverlayImageBanner/fullimage2.jpg?ce344b31";


//////////////////
// WEBPACK FOOTER
// ./src/components/WhyHost/OverlayImageBanner/fullimage2.jpg
// module id = 3387
// module chunks = 8